'use client';

import { useState, useCallback, useRef } from 'react';

export function useUploadMethodMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLibraryOpen, setIsLibraryOpen] = useState(false);
  const proceedRef = useRef<(() => void) | null>(null);

  const onBeforeOpen = useCallback((proceed: () => void) => {
    proceedRef.current = proceed;
    setIsMenuOpen(true);
  }, []);

  const handleUploadNew = useCallback(() => {
    setIsMenuOpen(false);
    proceedRef.current?.();
  }, []);

  const handleChooseExisting = useCallback(() => {
    setIsMenuOpen(false);
    setIsLibraryOpen(true);
  }, []);

  const closeMenu = useCallback(() => setIsMenuOpen(false), []);
  const closeLibrary = useCallback(() => setIsLibraryOpen(false), []);

  return {
    isMenuOpen,
    isLibraryOpen,
    onBeforeOpen,
    handleUploadNew,
    handleChooseExisting,
    closeMenu,
    closeLibrary
  };
}
